import React, { useState } from "react";

import MaterialDialog from "@material-ui/core/Dialog";

export default function Dialog({
  render,
  close,
  ...props
}: {
  render: ({ close }: { close: () => void }) => React.ReactNode;
  close?: () => void;
}) {
  const [isOpen, setOpenState] = useState(true);
  const onClose = () => {
    setOpenState(false);

    if (close) {
      close();
    }
  };

  return (
    <MaterialDialog open={isOpen} onClose={onClose} {...props}>
      {render({ close: onClose })}
    </MaterialDialog>
  );
}
